'use strict';

var getStylePrefixed = require('./getStylePrefixed')
var properties       = require('./prefixProps')

module.exports = function(key, value){

	if (!properties[key]){
		return key
	}

	return getStylePrefixed(key, value)
}


//////////////////
// WEBPACK FOOTER
// ./~/react-style-normalizer/src/getPrefixed.js
// module id = 1446
// module chunks = 0